
import { APIClient } from "api/api_helper";
import { LIBRARY_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";
import Template from "../helper/template.types";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// TEMPLATE API
// ------------------------------------------------------------------

export const templateApiService = {

  // SELECT ALL METHOD
  getSelectAllData: (
      params: Template
  ) => {
    return api.create(LIBRARY_API.TEMPLATE_API + "SelectAll", params);
  },

  // Detail SelectAll METHOD
  getDetailSelectAllData: (params: Template) => {
  return api.create(
    LIBRARY_API.TEMPLATE_API + "Select",
    params
  );
},

  // INSERT METHOD
insertData: (data: Template) => {
  const user = GetUserData() as CurrentUser;

  const payload = {
    ...data,
    createdby: user.userid,
  };

  return api.create(
    LIBRARY_API.TEMPLATE_API + "Insert",
    payload
  );
},

  // UPDATE METHOD
updateData: (data: Template) => {
  const user = GetUserData() as CurrentUser;

  const payload = {
    ...data,
    updatedby: user.userid,
  };

  return api.create(
    LIBRARY_API.TEMPLATE_API + "Update",
    payload
  );
},

  // DELETE METHOD
deleteData: (data: Template) => {
  const user = GetUserData() as CurrentUser;

  const payload = {
    ...data,
    updatedby: user.userid,
  };

  return api.create(
    LIBRARY_API.TEMPLATE_API + "Delete",
    payload
  );
},

};
